// Port of api/fuel/app/classes/insights/records/users.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'
import User from 'offline/model/user'

function packageUsers(segment, users, detail, compareType) {
	var limit = detail ? 100 : 5
	var direction = compareType === 'most' ? 'desc' : 'asc'
	var items = Util.sort_by_field(users, 'ratio', direction).slice(0, limit)

	if (items.length) {
		var userModels = User.where([
			['user_id', 'in', Util.pluck(items, 'id')]
		]).associated()

		for (var i = 0; i < items.length; i++) {
			items[i].name = userModels[items[i].id] ? userModels[items[i].id].get_name() : ''
			segment._references.users.push(parseInt(items[i].id, 10))
		}
	}

	return items
}

export default Segment.extend({
	name: 'users',
	types: [Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
	requires: ['init'],
	insight: false,
	methods: {
		records_users_analysis: function(type, owner, userIndex) {
			var threshold = 100
			var plays = this._data.plays || []
			var total = {}
			var applicable = {}
			var wins = {}

			for (var i = 0; i < userIndex.length; i++) {
				total[userIndex[i]] = 0
				applicable[userIndex[i]] = 0
				wins[userIndex[i]] = 0
			}

			for (var p = 0; p < plays.length; p++) {
				var play = plays[p]
				if (play.result) applicable[play.user] += parseInt(play.count, 10)
				total[play.user] += parseInt(play.count, 10)
				if (play.won) wins[play.user] += parseInt(play.count, 10)
			}

			var users = []
			for (var u = 0; u < userIndex.length; u++) {
				var userId = userIndex[u]
				if (applicable[userId] && applicable[userId] >= threshold) {
					users.push({
						id: parseInt(userId, 10),
						total: total[userId],
						wins: wins[userId],
						applicable: applicable[userId],
						ratio: (100 / applicable[userId]) * wins[userId]
					})
				}
			}

			return users
		}
	},
	run: function(type, owner, userIndex, detail, filter, vars) {
		var threshold = 100
		var users = this.records_users_analysis(type, owner, userIndex)

		if (detail) {
			return {
				users: packageUsers(this, users, detail, vars.compareType)
			}
		}

		return {
			users: {
				threshold: threshold,
				most: packageUsers(this, users, detail, 'most'),
				least: packageUsers(this, users, detail, 'least')
			}
		}
	}
})
